import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Dispatch, bindActionCreators } from "redux";

import { getAssignmentsByCourseId, downloadAssignment } from "../../store/assignment/actions"
import { getCourseDetails } from "../../store/course/actions";
import { getTestExamsByCategoryId } from "../../store/testExams/actions";
import { CourseState } from "../../types/course";
import CoursesComponent from "./CoursesComponent";
import { AuthenticationState } from "../../types/auth";
import { SampleExamState } from "../../types/sampleExam";
import { AssignmentState } from "../../types/assignment";
import { ApplicationState } from "../../store";
import { Role } from "../../types/enum";

interface CoursesContainerProps {
    auth: AuthenticationState;
    course: CourseState;
    testExams: SampleExamState
    assignment: AssignmentState;
    studentId?: string;
    getCourseDetails: (studentId?: string, role?: string) => void;
    downloadAssignment: (assignmentId: number, name: string) => void;
    getTestExamsByCategoryId: (categoryId: number, projectId?: number) => void;
    getAssignmentsByCourseId: (courseId: string) => void;
}

const mapStateToProps = ({
    auth,
    course,
    testExams,
    assignment,
    student
}: ApplicationState) => {
    return ({
        auth,
        course,
        testExams,
        assignment,
        studentId: student.studentDetail?.studentId
    });
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return bindActionCreators({ getCourseDetails, getTestExamsByCategoryId, getAssignmentsByCourseId, downloadAssignment }, dispatch);
}

const CoursesContainer = ({ studentId, auth, course, getCourseDetails, getTestExamsByCategoryId, testExams, getAssignmentsByCourseId, assignment, downloadAssignment }: CoursesContainerProps) => {

    useEffect(() => {
        if (studentId && auth.role === Role.ADMIN) getCourseDetails(studentId, auth.role);
        else if (auth.role !== Role.ADMIN) getCourseDetails(undefined, auth.role);
    }, [auth, studentId, getCourseDetails]);

    return <CoursesComponent
        auth={auth}
        courseDetail={course.courseDetail}
        loading={course.loading}
        error={course.error}
        testExams={testExams}
        assignment={assignment}
        getTestExamsByCategoryId={getTestExamsByCategoryId}
        getAssignmentsByCourseId={getAssignmentsByCourseId}
        downloadAssignment={downloadAssignment}
    />
};

export default connect(mapStateToProps, mapDispatchToProps)(CoursesContainer);